/**
 * The kinds of project asset a designer landing page lists, as the entity-modification
 * feed names them. Mirrors `EDesignerEntityKind` on the backend value for value — the
 * numbers travel on the wire (no string-enum converter is registered in CoreApi), so a
 * member may be appended but never renumbered or reordered.
 *
 * `ProjectConfiguration` and `DomainConfiguration` are separate kinds because they are
 * separate tables with separate scopes: the Config Manager's project surface asks for
 * both, its global surface for the domain one alone.
 */
export enum EDesignerEntityKind {
  Datasource = 0,
  Action = 1,
  ScheduledJob = 2,
  ApiManagement = 3,
  NotificationTemplate = 4,
  ProjectConfiguration = 5,
  DomainConfiguration = 6,
  ScreenDesign = 7,
  WorkFlow = 8
}
